import React, { useState, useEffect } from "react"; 
import { Button, Grid, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Card, CardContent } from "@mui/material";
import axios from "axios";
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink } from "@react-pdf/renderer";
import Modal from './Modal';
import ImprimoListas from "./ImprimoListas";

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// Define estilos para el PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 30,
    fontSize: 12,
  },
  section: {
    marginBottom: 20,
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    marginTop: 10,
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
  },
  tableCell: {
    padding: 5,
    width: "50%",
  },
});

const Dashboard = () => {
  const [conteoPorCondicion, setConteoPorCondicion] = useState({});
  const [cambiosAgrupadosPorFecha, setCambiosAgrupadosPorFecha] = useState({});
  const [totalCarpetas, setTotalCarpetas] = useState(0);
  const [carpetasConDiagnostico, setCarpetasConDiagnostico] = useState(0);
  const [conteoPorTipoDiagnostico, setConteoPorTipoDiagnostico] = useState({});
  const [carpetasAgrupadasPorDiagnostico, setCarpetasAgrupadasPorDiagnostico] = useState({});
  const [veoCadete, setVeoCadete] = useState(false);
  const [datoCondicion,setDatosCondicion]=useState("");
  const [datoSede,setDatosSede]=useState("");
  const [listadoSeleccionado,setListadoSeleccionado]=useState("");
  const [filtros, setFiltros] = useState({
    Todos: false,
    Convocado: false,
    Excluido: false,
    Regular: false,
    Propedeutico: false,
    Reempadronar: false,
    Renuncia: false,
    BAJA: false,
    LiEs: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/obtenerEstadisticasCadetes`
      );

      if (response && response.data) {
        const datos = response.data;
        setConteoPorCondicion(datos.conteoPorCondicion || {});
        setCambiosAgrupadosPorFecha(datos.cambiosAgrupadosPorFecha || {});
        setTotalCarpetas(datos.totalCarpetas || 0);
        setCarpetasConDiagnostico(datos.carpetasConDiagnostico || 0);
        setConteoPorTipoDiagnostico(datos.conteoPorTipoDiagnostico || {});
        setCarpetasAgrupadasPorDiagnostico(datos.carpetasAgrupadasPorDiagnostico || {});
      }
    };

    fetchData();
  }, []);

  // Función para exportar cambios agrupados en Excel
const exportCambiosAExcel = () => {
  let datosExcel = [];

  Object.keys(cambiosAgrupadosPorFecha).forEach((sede) => {
    // Ordeno fechas descendente
    const fechasOrdenadas = Object.keys(cambiosAgrupadosPorFecha[sede]).sort((a,b) => new Date(b) - new Date(a));

    fechasOrdenadas.forEach((fecha) => {
      cambiosAgrupadosPorFecha[sede][fecha].forEach(cambio => {
        datosExcel.push({
          Sede: sede,
          Fecha: fecha,
          Cadete: `${cambio.cadeteNombre} ${cambio.cadeteApellido}`,
          DNI: cambio.cadeteDni,
          Condicion_Anterior: cambio.condicionAnterior,
          Condicion_Actual: cambio.condicionActual,
        });
      });
    });
  });

  const ws = XLSX.utils.json_to_sheet(datosExcel);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "CambiosSituacion");
const fechaHoy=new Date()
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], { type: 'application/octet-stream' });
  saveAs(blob, 'CambiosSituacion_'+fechaHoy.toLocaleDateString()+"_"+fechaHoy.toLocaleTimeString()+'.xlsx');
};


  // Componente para exportar el PDF
  const MyDocument = () => (
    <Document>
      <Page style={styles.page}>
        {/* Conteo por Condición */}
        <View style={styles.section}>
          <Text style={{ fontSize: 14, fontWeight: "bold" }}>Cantidad por Condición de Cursantes</Text>
          {Object.keys(conteoPorCondicion).length > 0 ? (
            Object.keys(conteoPorCondicion).map((sede) => (
              <View key={sede}>
                <Text style={{ fontSize: 11, marginTop: 10 }}>{sede}</Text>
                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCell}>Condición</Text>
                    <Text style={styles.tableCell}>Cantidad</Text>
                  </View>
                  {Object.entries(conteoPorCondicion[sede]).map(([condicion, cantidad]) => (
                    <View key={condicion} style={styles.tableRow}>
                      <Text style={styles.tableCell}>{condicion}</Text>
                      <Text style={styles.tableCell}>{cantidad}</Text>
                    </View>
                  ))}
                </View>
              </View>
            ))
          ) : (
            <Text>No hay datos para mostrar en Conteo por Condición.</Text>
          )}
        </View>
        <View style={styles.section}>
          <Text style={{ fontSize: 14, fontWeight: "bold" }}>Listado de Cambios de Condicion</Text>
          <Text>Total de Cambios: </Text>
         
          <Text style={{ fontSize: 11, marginTop: 10 }}>Cantidad por Tipo de Diagnóstico</Text>
          {Object.keys(conteoPorTipoDiagnostico).length > 0 ? (
            Object.entries(conteoPorTipoDiagnostico).map(([tipo, diagnosticos]) => (
              <View key={tipo} style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={styles.tableCell}>Diagnóstico</Text>
                  <Text style={styles.tableCell}>Cantidad</Text>
                </View>
                {Object.entries(diagnosticos).map(([diagnostico, cantidad]) => (
                  <View key={diagnostico} style={styles.tableRow}>
                    <Text style={styles.tableCell}>{diagnostico}</Text>
                    <Text style={styles.tableCell}>{cantidad}</Text>
                  </View>
                ))}
              </View>
            ))
          ) : (
            <Text>No hay información médica disponible.</Text>
          )}
        </View>
        {/* Información Médica */}
        <View style={styles.section}>
          <Text style={{ fontSize: 14, fontWeight: "bold" }}>Información Médica</Text>
          <Text>Total de Carpetas: {totalCarpetas}</Text>
          <Text>Carpetas con Diagnóstico: {carpetasConDiagnostico}</Text>

          <Text style={{ fontSize: 11, marginTop: 10 }}>Cantidad por Tipo de Diagnóstico</Text>
          {Object.keys(conteoPorTipoDiagnostico).length > 0 ? (
            Object.entries(conteoPorTipoDiagnostico).map(([tipo, diagnosticos]) => (
              <View key={tipo} style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={styles.tableCell}>Diagnóstico</Text>
                  <Text style={styles.tableCell}>Cantidad</Text>
                </View>
                {Object.entries(diagnosticos).map(([diagnostico, cantidad]) => (
                  <View key={diagnostico} style={styles.tableRow}>
                    <Text style={styles.tableCell}>{diagnostico}</Text>
                    <Text style={styles.tableCell}>{cantidad}</Text>
                  </View>
                ))}
              </View>
            ))
          ) : (
            <Text>No hay información médica disponible.</Text>
          )}
        </View>

        {/* Carpetas Agrupadas por Diagnóstico */}
        <View style={styles.section}>
          <Text style={{ fontSize: 13, fontWeight: "bold" }}>Carpetas Agrupadas por Diagnóstico y Sede</Text>
          {Object.keys(carpetasAgrupadasPorDiagnostico).length > 0 ? (
            Object.keys(carpetasAgrupadasPorDiagnostico).map((sede) => (
              <View key={sede}>
                <Text style={{ fontSize: 12, marginTop: 10 }}>{sede}</Text>
                {Object.entries(carpetasAgrupadasPorDiagnostico[sede]).map(([diagnostico, cadetes]) => (
                  <View key={diagnostico}>
                    <Text style={{ fontSize: 10, marginTop: 8 }}>Diagnóstico: {diagnostico}</Text>
                    {cadetes.map((cadete, index) => (
                      <Text key={index}>
                        {cadete.cadeteNombre} {cadete.cadeteApellido} ({cadete.cadeteDni})
                      </Text>
                    ))}
                  </View>
                ))}
              </View>
            ))
          ) : (
            <Text>No hay carpetas agrupadas por diagnóstico.</Text>
          )}
        </View>
      </Page>
    </Document>
  );

  const manejoClick=async(sede,condicion)=>{
    setDatosCondicion(condicion);
    setDatosSede(sede);
    const cond=[condicion];

    const response = await axios.post(
      `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadetesPorSede/${sede}`,
      {
        cadeteEstado: "Activo",  // Puedes ajustar este valor según tu lógica
        cadeteCondicion: cond,  // Pasando los filtros seleccionados
      }
    );

//     console.log(response.data);
    setListadoSeleccionado(response.data);
    setVeoCadete(true);
  };

  return (
    <div>
      {conteoPorCondicion && cambiosAgrupadosPorFecha ? (
        <Grid container spacing={3} padding={2}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Condiciones de Cadetes 
                </Typography>
                {conteoPorCondicion && Object.keys(conteoPorCondicion).length > 0 ? (
                  Object.keys(conteoPorCondicion).map((sede) => (
                    <Paper key={sede} elevation={3} style={{ marginBottom: 16, padding: 16 }}>
                      <Typography variant="h6">{sede}</Typography>
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Condición</TableCell>
                              <TableCell>Cantidad</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {conteoPorCondicion[sede] && Object.entries(conteoPorCondicion[sede]).map(([condicion, cantidad]) => (
                              <TableRow onClick={()=>manejoClick(sede,condicion)} key={condicion} style={{ cursor: "pointer" }}>
                                <TableCell>{condicion}</TableCell>
                                <TableCell>{cantidad}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  ))
                ) : (
                  <Typography variant="body1">No hay datos para mostrar.</Typography>
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6} > 
            <Card >
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Renuncias y Cambios Agrupados por Fecha
                </Typography>
                {cambiosAgrupadosPorFecha && Object.keys(cambiosAgrupadosPorFecha).length > 0 ? (
                  Object.keys(cambiosAgrupadosPorFecha).map((sede) => (
                    <Paper key={sede} elevation={3} style={{ marginBottom: 16, padding: 16, overflow:"auto", height:"300px", }}>
                      <Typography variant="h4">{sede}</Typography>
                      {cambiosAgrupadosPorFecha[sede] && 
                        // Ordeno fechas descendente (más nuevo primero)
                        Object.keys(cambiosAgrupadosPorFecha[sede])
                          .sort((a, b) => new Date(b) - new Date(a))
                          .map((fecha) => (
                        <div key={fecha}>
                          <Typography variant="h5" style={{ marginTop: 8,color:"red"}}>Fecha: {fecha}</Typography>
                          {cambiosAgrupadosPorFecha[sede][fecha].map((cambio, index) => (
                            <Paper key={index} elevation={1} style={{ marginTop: 8, padding: 8 }}>
                              <Typography variant="body3">
                                <strong>Cadete:</strong> {cambio.cadeteNombre} {cambio.cadeteApellido} ({cambio.cadeteDni})
                              </Typography>
                              <Typography variant="body3">
                                <strong>Condición Anterior:</strong> {cambio.condicionAnterior}
                              </Typography>
                              <Typography variant="body3">
                                <strong>Condición Actual:</strong> {cambio.condicionActual}
                              </Typography>
                            </Paper>
                          ))}
                        </div>
                      ))}
                    </Paper>
                  ))
                ) : (
                  <Typography variant="body1">No hay cambios para mostrar.</Typography>
                )}
              </CardContent>
               <Button variant="outlined" onClick={exportCambiosAExcel} style={{ marginBottom: 16 }}>
        Descargar Cambios en Excel
      </Button>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Información Médica
                </Typography>
                <Typography variant="body1">
                  Total de Carpetas: {totalCarpetas}
                </Typography>
                <Typography variant="body1">
                  Carpetas con Diagnóstico: {carpetasConDiagnostico}
                </Typography>

                <Typography variant="h6" style={{ marginTop: 16 }}>
                  Cantidad por Tipo de Diagnóstico
                </Typography>
                {Object.keys(conteoPorTipoDiagnostico).length > 0 ? (
                  Object.entries(conteoPorTipoDiagnostico).map(([tipo, diagnosticos]) => (
                    <Paper key={tipo} elevation={3} style={{ marginBottom: 16, padding: 16 }}>
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Diagnóstico</TableCell>
                              <TableCell>Cantidad</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Object.entries(diagnosticos).map(([diagnostico, cantidad]) => (
                              <TableRow key={diagnostico}>
                                <TableCell>{diagnostico}</TableCell>
                                <TableCell>{cantidad}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  ))
                ) : (
                  <Typography variant="body1">No hay información médica disponible.</Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      ) : (
        <Typography variant="body1">Cargando datos...</Typography>
      )}

      {/* Botón para descargar el PDF */}
      <PDFDownloadLink document={<MyDocument />} fileName="informe_cadetes.pdf" style={{ marginRight: 8 }}>
        {({ loading }) => (loading ? <Button disabled>Cargando PDF...</Button> : <Button variant="contained">Descargar Informe PDF</Button>)}
      </PDFDownloadLink>

      {/* Botón para descargar Excel */}
     

      {veoCadete && (
        <div
          style={{
            padding: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Modal isOpen={veoCadete} onClose={() => setVeoCadete(false)}>
            <div
              style={{
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{overflowY:"auto", height:"500px"}}>
                <h4>{datoCondicion}s de {datoSede}</h4>
                <ImprimoListas cadetesData={listadoSeleccionado} titulo={datoCondicion} />
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
